/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-24T16:23:29.588
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveFinancialPaymentItem,
	getFinancialPaymentItemCreateInit,
	getFinancialPaymentItemEditInit,
	getFinancialPaymentItemView,
	deleteFinancialPaymentItem
} from '@api/financial/FinancialPaymentItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinancialPaymentItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialPaymentItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialPaymentItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialPaymentItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialPaymentItem({}, FinancialPaymentItem) {
			return new Promise((resolve, reject) => {
				saveFinancialPaymentItem(FinancialPaymentItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialPaymentItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialPaymentItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPaymentItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPaymentItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
